import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchDocuments } from "../../../../services/httpClient";
import ToastMsg from "../../../ui/ToastMsg";
import { ViewFiles } from "./ViewFiles";
import FileUploadDocuments from "./FileUploadDocuments";
import { Button, Container, Spinner } from "react-bootstrap";
import PageTitle from "../../../ui/PageTitle";

interface DocumentsState {
  myCase: boolean;
  getData: boolean;
  setUserToSave: any;
}

const Documents = ({ myCase, getData, setUserToSave }: DocumentsState) => {
  const { id } = useParams();
  const [docs, setDocs] = useState<any>();
  const [noteDocs, setNoteDocs] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const [showUpload, setShowUpload] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");

  useEffect(() => {
    if (getData) {
      setIsLoading(true);
      getDocuments();
    }
  }, [getData]);

  const getDocuments = async () => {
    await fetchDocuments(id)
      .then((res: any) => {
        const documents = res[0].data.case;
        setDocs(documents);
        const noteDocuments = res[0].data.note;
        setNoteDocs(noteDocuments);
        setIsLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />

      {isLoading ? (
        <Container>
          <Button size="sm" className="spinner-button spinner-button-main">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </Button>
        </Container>
      ) : (
        <>
          {myCase ? (
            <>
              <PageTitle
                title="Documents"
                type="section"
                buttonTitle={showUpload ? "Close Upload" : "Upload"}
                onButtonClick={() => setShowUpload(!showUpload)}
              />
              {showUpload && (
                <FileUploadDocuments
                  header="Upload Case Document"
                  fetchDocuments={getDocuments}
                  setShowToast={setShowToast}
                  setToastText={setToastText}
                  setToastBody={setToastBody}
                  setUserToSave={setUserToSave}
                />
              )}
            </>
          ) : (
            <PageTitle title="Case Documents" type="section" />
          )}
          {docs?.length === 0 ? (
            <p className="mt-2">No Documents</p>
          ) : (
            <ViewFiles
              docs={docs}
              fetchDocuments={getDocuments}
              myCase={myCase}
              setIsLoading={setIsLoading}
              type="Case"
              setShowToast={setShowToast}
              setToastText={setToastText}
              setToastBody={setToastBody}
            />
          )}
          <PageTitle title="Documents in a Note" type="section" />
          {noteDocs?.length === 0 ? (
            <p className="mt-2">No Documents</p>
          ) : (
            <ViewFiles
              docs={noteDocs}
              fetchDocuments={getDocuments}
              myCase={myCase}
              setIsLoading={setIsLoading}
              type="Note"
              setShowToast={setShowToast}
              setToastText={setToastText}
              setToastBody={setToastBody}
            />
          )}
        </>
      )}
    </>
  );
};

export default Documents;
